import { render, staticRenderFns } from "./DeviceManage.vue?vue&type=template&id=4a64c797&scoped=true&"
import script from "./DeviceManage.vue?vue&type=script&lang=js&"
export * from "./DeviceManage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManage.vue?vue&type=style&index=0&id=4a64c797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64c797",
  null
  
)

export default component.exports